// extracted by mini-css-extract-plugin
export default {"activatedContent":"Activated_activatedContent__fk5dX","bgBlue":"Activated_bgBlue__Ej1wj","infoContent":"Activated_infoContent__A6FVx","verifyIcon":"Activated_verifyIcon__Swoza"};